import React from 'react'
import { useQuickSearchQuery } from './SelectEntitiesForm.codegen'
import Loader from 'front-end/src/components/common/loader/Loader'
import { SearchableItemTypesEnum } from 'shared/enums/common'
import {
  SelectEntitiesModalDataContext,
  SelectEntitiesModalDataContextType
} from './context'
import { SearchableEntity } from './SelectEntitiesForm.types'

type FetchEntitiesFromBackendProps = {
  entityType: SearchableItemTypesEnum
}

export const FetchEntitiesFromBackend: React.FC<FetchEntitiesFromBackendProps> =
  ({ entityType, children }) => {
    const { data, loading } = useQuickSearchQuery({
      variables: {
        titleFilter: '',
        include: [entityType]
      }
    })

    const resources = React.useMemo((): SearchableEntity[] => {
      return (data?.admin?.quickSearch as unknown as SearchableEntity[]) ?? []
    }, [data])

    const contextValue = React.useMemo(
      (): SelectEntitiesModalDataContextType => ({
        entities: resources
      }),
      [resources]
    )

    if (loading) {
      return <Loader />
    }

    return (
      <SelectEntitiesModalDataContext.Provider value={contextValue}>
        {children}
      </SelectEntitiesModalDataContext.Provider>
    )
  }
